class GridLayout extends HTMLElement {
  constructor() {
    super();
    this.grids = this.closest('.collection-wrapper').querySelectorAll('.collection-subcategory__grid');
    this.triggers = this.querySelectorAll('a');

    this.onGrigChange();
    this.detectFilters();
  }

  onGrigChange() {
    this.triggers.forEach(trigger => {
      trigger.addEventListener('click', (event) => {
        event.preventDefault();

        const layout = trigger.dataset.layout

        this.triggers.forEach(sibling => {
          if (sibling !== trigger) {
            sibling.classList.remove('active');
          };
        });

        trigger.classList.add('active');

        this.toggleLayOut(layout);
      });
    });
  }

  detectFilters() {
    const promotions = document.querySelectorAll('.promotion-item');

    if (window.location.search.includes('filter')) {
      promotions.forEach(promotion => {
        promotion.classList.add('hidden');
      });
    } else {
      promotions.forEach(promotion => {
        promotion.classList.remove('hidden');
      });
    }
  }

  toggleLayOut(selectedLayout) {
    this.grids.forEach(grid => {
      const activeClass = 'collection-subcategory__grid--single';

      selectedLayout === '1'
        ? grid.classList.add(activeClass)
        : grid.classList.remove(activeClass);
    });
  }
}

customElements.define('grid-layout', GridLayout);
